module.exports = __webpack_public_path__ + "img/logo_nemo.89cc3230.jpg";